import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useUIContext } from "../context/UI";
import SkipButton from "./SkipButton";
import SkipButtonNew from "./SkipButtonNew";
import { jsx as _jsx } from "react/jsx-runtime";
var SkipButtonIndex = function SkipButtonIndex(props) {
  var _useUIContext = useUIContext(),
    visibleAI = _useUIContext.visibleAI;
  return visibleAI ? /*#__PURE__*/_jsx(SkipButtonNew, _objectSpread({}, props)) : /*#__PURE__*/_jsx(SkipButton, _objectSpread({}, props));
};
export default SkipButtonIndex;